import gql from 'graphql-tag';

import publicAccountFragment from '../fragments/publicAccountFragment';

export const queryAccountBySlug = gql`
  query accountBySlug($slug: String!) {
    accountBySlug(slug: $slug) {
      ...publicAccountFragment
    }
  }
  ${publicAccountFragment}
`;

export default queryAccountBySlug;
